import React from 'react';
import { animations } from '../../theme/animations';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  color?: string;
  className?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'medium',
  color = 'var(--color-primary)',
  className = ''
}) => {
  const sizeMap = {
    small: '16px',
    medium: '24px',
    large: '40px'
  };

  const borderWidth = size === 'small' ? '2px' : size === 'medium' ? '3px' : '4px';

  return (
    <div 
      style={{
        width: sizeMap[size],
        height: sizeMap[size],
        border: `${borderWidth} solid var(--color-gray-200)`,
        borderTopColor: color,
        borderRadius: '50%',
        ...animations.spin
      }}
      role="status"
      aria-label="Loading"
    />
  );
};